import { EventsName } from './types'
import type { ModalEvent } from './types'

export const modalEventDispatch = <T>(payload: ModalEvent<T>) =>
  window.dispatchEvent(new CustomEvent(EventsName.DEFAULT, { detail: { ...payload } }))

export const modalEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.DEFAULT, listener)

  return () => window.removeEventListener(EventsName.DEFAULT, listener)
}

export const modalDeleteGroupCommunityEventDispatch = <T>(payload: ModalEvent<T>) =>
  window.dispatchEvent(new CustomEvent(EventsName.DELETE_GROUP_MODAL, { detail: { ...payload } }))

export const modalDeleteGroupCommunityEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.DELETE_GROUP_MODAL, listener)

  return () => window.removeEventListener(EventsName.DELETE_GROUP_MODAL, listener)
}

export const modalUnbanMemberCommunityEventDispatch = <T>(payload: ModalEvent<T>) =>
  window.dispatchEvent(
    new CustomEvent(EventsName.UNBAN_MEMBER_COMMUNITY, { detail: { ...payload } })
  )

export const modalUnbanMemberCommunityEventListener = (listener: (event: Event) => void) => {
  window.addEventListener(EventsName.UNBAN_MEMBER_COMMUNITY, listener)

  return () => window.removeEventListener(EventsName.UNBAN_MEMBER_COMMUNITY, listener)
}
